import React, { useContext } from 'react';
import loadAgentFromCDN from '@tr-digital/appdynamics-client-agent';
import { v4 } from 'uuid';

var ConsoleLogger = function ConsoleLogger() {
  this.debug = function (msg) {
    var _console;

    for (var _len = arguments.length, optionalParams = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      optionalParams[_key - 1] = arguments[_key];
    }

    (_console = console).debug.apply(_console, [msg].concat(optionalParams));
  };

  this.info = function (msg) {
    var _console2;

    for (var _len2 = arguments.length, optionalParams = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      optionalParams[_key2 - 1] = arguments[_key2];
    }

    (_console2 = console).info.apply(_console2, [msg].concat(optionalParams));
  };

  this.warn = function (msg) {
    var _console3;

    for (var _len3 = arguments.length, optionalParams = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
      optionalParams[_key3 - 1] = arguments[_key3];
    }

    (_console3 = console).warn.apply(_console3, [msg].concat(optionalParams));
  };

  this.error = function (err) {
    var _console4;

    for (var _len4 = arguments.length, optionalParams = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
      optionalParams[_key4 - 1] = arguments[_key4];
    }

    (_console4 = console).error.apply(_console4, [err.message].concat(optionalParams));
  };

  this.trace = function (msg) {
    var _console5;

    for (var _len5 = arguments.length, optionalParams = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
      optionalParams[_key5 - 1] = arguments[_key5];
    }

    (_console5 = console).trace.apply(_console5, [msg].concat(optionalParams));
  };
};

var LoggerContext = /*#__PURE__*/React.createContext( /*#__PURE__*/new ConsoleLogger());

var AppDynamicsLogger = function AppDynamicsLogger(apiKey, identifier) {
  var _this = this;

  // this method responsibility is to create the log message using AppDynamics SDK
  // and report it by using ADRUM global object.
  // ADRUM is AppDynamics client agent object that provides monitor and log capabilities.
  this.logMessage = function (msg, logLevel, stack) {
    if (msg === void 0) {
      msg = '';
    }

    var errorT = new window.ADRUM.events.Error();

    for (var _len = arguments.length, optionalParams = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
      optionalParams[_key - 3] = arguments[_key];
    }

    var framedMsg = _this.buildMessage(msg, optionalParams);

    errorT.msg(framedMsg + "\nlog-level: " + logLevel);
    errorT.url(window.location.href);
    errorT.line(0);
    errorT.stack(stack || '');
    window.ADRUM.report(errorT);
  };

  this.buildMessage = function (msg) {
    for (var _len2 = arguments.length, optionalParams = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      optionalParams[_key2 - 1] = arguments[_key2];
    }

    if (!optionalParams || !optionalParams.length) {
      return msg || '';
    }

    var stringifiedParams = optionalParams.reduce(function (msgAccumaltor, param) {
      msgAccumaltor.push(JSON.stringify(param));
      return msgAccumaltor;
    }, []);
    var framedMsg = (msg || '') + "\nparams: " + stringifiedParams.join(' ');
    return framedMsg;
  };

  this.debug = function (msg) {
    for (var _len3 = arguments.length, optionalParams = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
      optionalParams[_key3 - 1] = arguments[_key3];
    }

    _this.logMessage(msg, 'Debug', '', optionalParams);
  };

  this.info = function (msg) {
    for (var _len4 = arguments.length, optionalParams = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
      optionalParams[_key4 - 1] = arguments[_key4];
    }

    _this.logMessage(msg, 'Info', '', optionalParams);
  };

  this.warn = function (msg) {
    for (var _len5 = arguments.length, optionalParams = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
      optionalParams[_key5 - 1] = arguments[_key5];
    }

    _this.logMessage(msg, 'Warn', '', optionalParams);
  };

  this.error = function (ex) {
    var msg = "session-id: " + _this.identifier + "\nmsg: " + ex.message + "\nstack: " + ex.stack;

    for (var _len6 = arguments.length, optionalParams = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
      optionalParams[_key6 - 1] = arguments[_key6];
    }

    _this.logMessage(msg, 'Error', ex.stack, optionalParams);
  };

  this.trace = function (msg) {
    for (var _len7 = arguments.length, optionalParams = new Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
      optionalParams[_key7 - 1] = arguments[_key7];
    }

    _this.logMessage(msg, 'Trace', '', optionalParams);
  };

  if (!apiKey) {
    throw new Error('apiKey is required');
  }

  this.identifier = identifier || v4();
  loadAgentFromCDN(apiKey, 'SPA');
};

var MultiTransportLogger = /*#__PURE__*/function () {
  function MultiTransportLogger() {
    var _this = this;

    this.loggers = [];

    this.debug = function (msg) {
      for (var _len = arguments.length, optionalParams = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        optionalParams[_key - 1] = arguments[_key];
      }

      _this.loggers.forEach(function (logger) {
        logger.debug.apply(logger, [msg].concat(optionalParams));
      });
    };

    this.info = function (msg) {
      for (var _len2 = arguments.length, optionalParams = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        optionalParams[_key2 - 1] = arguments[_key2];
      }

      _this.loggers.forEach(function (logger) {
        logger.info.apply(logger, [msg].concat(optionalParams));
      });
    };

    this.warn = function (msg) {
      for (var _len3 = arguments.length, optionalParams = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        optionalParams[_key3 - 1] = arguments[_key3];
      }

      _this.loggers.forEach(function (logger) {
        logger.warn.apply(logger, [msg].concat(optionalParams));
      });
    };

    this.error = function (err) {
      for (var _len4 = arguments.length, optionalParams = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        optionalParams[_key4 - 1] = arguments[_key4];
      }

      _this.loggers.forEach(function (logger) {
        logger.error.apply(logger, [err].concat(optionalParams));
      });
    };

    this.trace = function (msg) {
      for (var _len5 = arguments.length, optionalParams = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
        optionalParams[_key5 - 1] = arguments[_key5];
      }

      _this.loggers.forEach(function (logger) {
        logger.trace.apply(logger, [msg].concat(optionalParams));
      });
    };
  }

  var _proto = MultiTransportLogger.prototype;

  _proto.register = function register(logger) {
    this.loggers.push(logger);
  };

  return MultiTransportLogger;
}();

var buildAppLogger = function buildAppLogger(type, config) {
  var appLogger = new MultiTransportLogger();

  if (type === 'appDynamics') {
    var appDynamicsLogger = new AppDynamicsLogger((config == null ? void 0 : config.key) || '');
    appLogger.register(appDynamicsLogger);
  } else {
    appLogger.register(new ConsoleLogger());
  }

  return appLogger;
};

var useLogger = function useLogger() {
  return useContext(LoggerContext);
};

export { LoggerContext, buildAppLogger, useLogger };
//# sourceMappingURL=app-logger.esm.js.map
